exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btn-dropdown-themeSelection {\n  background-color: #1594A6;\n  display: block; }\n\n.theme-label {\n  font-size: 1rem; }\n\n.thumbnail {\n  display: block;\n  width: 179px;\n  height: 118px;\n  margin-bottom: 10px;\n  cursor: pointer; }\n\n.my-drop-zone {\n  border: dotted 3px lightgray;\n  text-align: center;\n  line-height: 4em; }\n\n/* Default class applied to drop zones on over */\n.invalid-drag {\n  border: dotted 3px red; }\n\n.valid-drag {\n  border: dotted 3px green; }\n\n.delete-icon {\n  color: #9c9b99; }\n\n.delete-icon:hover {\n  color: #76797E; }\n\n.delete-link {\n  position: absolute;\n  right: 15px;\n  top: 5px; }\n\n.progressBackground {\n  background: #DADADC !important; }\n\n.progressForeground {\n  background: #1594A6 !important; }\n\n.thumb-container {\n  position: relative;\n  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff; }\n\n.right-align {\n  text-align: right; }\n\n.center-align {\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/epic-gallery/epic-gallery.component.scss
// module id = ../../../../../src/app/components/epic-gallery/epic-gallery.component.scss
// module chunks = main